
<template>
  <section>
    <pageHeader>PRACTICE MANAGEMENT & CRM</pageHeader>
    <UnderLinedHeader class="pt-15 pb-8 white"
      >Practice Made Perfect</UnderLinedHeader
    >
    <v-row  align="center" class="pt-0 pb-16 pr-16 pl-16">
      <p class="artice-text text-center">
        What is practice management? Using processes together with technology to optimize performance and maximize the efficiency of an attorney’s office. This will make the lawyers, legal assistants and staff professionals more efficient, effective, ethical and responsive to the needs of their clients. 3545 helps organize manage client information to organize your practice to keep client data at your fingertips.<br><br>
        CRM (Customer Relationship Management) means keeping track of your leads and referral sources, following the sales cycle and tracking the results of customer purchases and relationships. Data organization is the key. 3545 consultants help you get organized and stay organized to give you the competitive edge.
        Amicus® Attorney provides comprehensive legal"
      </p>
      </v-row>
    
    <v-row justify="space-around">
      <v-col
        align="center"
        cols="12"
        s="12"
        xs="12"
        lg="4"
        xl="4"
        md="6"
        v-for="(item, index) in softwares_details"
        :key="index"
      >
      <FlipCard >
        <template v-slot:front>
         
             <imageCard :imageName="item.imageName" :alt="item.imageName" parentFolder="Softwares"> </imageCard>
           
        </template>
        <template v-slot:back >
            <div  class="card_text_style" v-html="item.content"></div>
             <v-btn color="#ebebeb">
                <a
                  v-bind:href="item.url"
                  target="_blank"
                  style="text-decoration: none"
                  ><span style="color: #666">Learn More</span></a
                >
              </v-btn>
        </template>
      </FlipCard>
      
     
      </v-col>
    </v-row>
  </section>
</template>

<script>
import PageHeader from "@/components/global/compnentsMixins/PageHeader.vue";
import UnderLinedHeader from "@/components/global/compnentsMixins/UnderLinedHeader.vue";
import FlipCard from "@/components/global/compnentsMixins/FlipCard.vue";
import ImageCard from "@/components/global/ImageCard.vue";
export default {
  components: { PageHeader, UnderLinedHeader, FlipCard,ImageCard },
  data(){
    return{
      softwares_details: [
        {
          imageName: 'amicus-360px.png',
          content:
            "Amicus® Attorney provides comprehensive legal scheduling that works the way you do. Manage appointments, tasks, deadlines (and more) for yourself, everyone in your workgroup or your entire firm. Practice information is seamlessly integrated with your favorite applications, into a single automated system for improved efficiency and profitability.",
          url: "https:www.amicusattorney.com/",
        },
         {
           imageName: 'bec-360px.png',
           content:
             "BEC CoreRelate Framework® is a customizable, secure legal database designed specifically for Microsoft Office.  Users use Word and Outlook creatively to help them manage, organize and automate matter workflow.  What could be better than a product that does the same thing, in a structured way.  BEC’s CoreRelate does just that.",
           url: "https:www.beclegal.com/products",
         },
         {
           imageName: 'clio-360px.png',
           content:
             "Clio® in the cloud allows you to access your client data securely anywhere—from your PC, your Mac, and even your iPhone. No need for a PC back at the office to store your data. It is in the cloud! Total cost of ownership for the solo or small firm is reduced by eliminating the need to store your data.",
           url: "https:www.goclio.com/",
         },
         {
           imageName: 'cosmolex-360px.png',
           content:
             "Cosmolex is a true cloud product that gives a growing law practice anytime, anywhere access to Legal Time & Billing, Trust (IOLTA) accounting, Document Mangagement, Calendar & Task and Business Accounting.  This all-in-one product is the small firm’s answer to reducing overhead and capitalizing on a cloud based all-in-one.",
           url: "https:www.cosmolex.com/",
         },
         {
           imageName: 'credenza-360px.png',
           content:
             "Credenza® is practice management built into the familiar framework of Microsoft Outlook, adding the professional practice management features of a full firm-wide practice management solution including collaboration tools, cloud document management, integrated billing and much more.",
           url: "http:www.credenzasoft.com/",
         },
         {
           imageName: 'daylite-360px.png',
           content:
             "Daylite is a business productivity manager designed for the Apple Mac OSX environment. Daylite’s ecosystem includes other Apple products, such as the iPhone and iPad, allowing users access to data when outside of the office. Daylite can be customized to help any business manage projects, sales, contacts, tasks, appointments, meetings, notes, and email.",
           url: "https:quickbooks.intuit.com/",
         },
         {
           imageName: 'houdini-360px.png',
           content:
             "HoudiniESQ is anywhere, anytime practice management. It runs entirely in your browser –there are no executables to install outside of the standard Flash player. Although it is a browser-based program, Houdini has many of the advanced features of traditional thick-client solutions such as workflow management, document management, document assembly and email management.",
           url: "http:houdiniesq.com/",
         },
         {
           imageName: 'lexisnexis-360px.png',
           content:
             "Gain mastery over the complete customer lifecycle with a single, affordable solution utilizing award-winning resources.<br/> Optimize your firm’s practice management, legal research, litigation services and client development workflow by using integrated LexisNexis Total Practice Advantage.",
           url: "https:www.lexisnexis.com/legalnewsroom/litigation/b/productupdate/archive/2010/03/25/lexisnexis-total-practice-advantage-integrates-everything-needed-to-practice-law.aspx?Redirected=true",
         },
         {
           imageName: 'TImeMatters-NEW-360px.png',
           content:
             "Time Matters®, formerly LexisNexis Time Matters, answers the case management needs for the small to mid-sized law firm. PracticeMaster has a wealth of different areas of law built into the software, allowing your firm to be up is the premier firm management product.  It is equally adept with Law Firms, Legal Departments, Government Agencies and Small Business.",
           url: "http:www.lexisnexis.com/business-of-law/products/practice-management/time-mattershttps:www.tabs3.com/products/practicemaster/practicemaster_features.html",
         },
         {
           imageName: 'zola-360px.png',
           content:
             "Zola Suite® is an end-to-end practice management platform that delivers a single source of truth. Zola Suite gives you the power of one solution to manage every action taken in every case. One complete, easy-to-use platform. One set of login credentials. One monthly bill.",
           url: "https:zolasuite.com/",
         },
         {
           imageName: 'centerbase-360px.png',
           content:
             "Centerbase is the all-in one legal platform that doesn’t disrupt your workflow—so you can focus on high-value work while automating low-value tasks.",
           url: "https:centerbase.com/",
         },
      ]
    };
  },
};
</script>

<style lang="scss" scoped>
p.artice-text {
  font-family: $primaryFontFamily;
  font-size: 1em;
}
</style>